// extracted by mini-css-extract-plugin
export default {"note":"EYqYoF","icon":"dSjKIL"};